module.exports = __webpack_public_path__ + "static/media/prevIcon.017493f5.svg";